<template>
    <div>
        <div class="content-box mr60">
            <el-form ref="form" label-width="120px" v-loading="formLoading" :model="formItem" :rules="rules" class="form-wrap">
                <el-form-item label="产品类型：" prop="app_type">
                    <ESelect v-model="formItem.app_type" @change="changeAppType" :disabled="isEdit" filterable clearable class="full-w" placeholder="请选择产品类型">
                        <el-option
                            v-for="item in appTypeList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                            {{item.name}}
                        </el-option>
                    </ESelect>
                </el-form-item>
                <el-form-item label="游戏分类：" prop="game_classify" v-if="formItem.app_type=='2'" class="label-required">
                    <ESelect v-model="formItem.game_classify" filterable clearable :disabled="isEdit" class="full-w" placeholder="请选择游戏分类">
                        <el-option
                            v-for="item in gameClassifyList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                            {{item.name}}
                        </el-option>
                    </ESelect>
                </el-form-item>
                <el-form-item label="素材类型：" prop="type">
                    <ESelect v-model="formItem.type" filterable clearable :disabled="isEdit" class="full-w" placeholder="请选择素材类型">
                        <el-option
                            v-for="item in typeList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                            {{item.name}}
                        </el-option>
                    </ESelect>
                </el-form-item>
                <el-form-item label="制作部门：" prop="group_id" class="label-required">
                    <JtLabelCascader
                        ref="JtLabelCascader"
                        placement="bottom-start"
                        size="mini"
                        class="mr20 full-w"
                        popper-class="cascader-mb20 cascader-x-scroll-auto cascader-list-height-360"
                        @change="changeGroup"
                        v-model="formItem.group_id"
                        :options="groupOptions"
                        :props="{value:'id',label:'name',emitPath:false,expandTrigger: 'click',multiple:true}"
                        :deleteLabels="deleteLabels"
                        :removeDelete="false"
                        :show-all-levels="false"
                        clearable
                        filterable
                        placeholder="请选择制作部门">
                    </JtLabelCascader>
                </el-form-item>
            </el-form>
        </div>
        <p class="dialog-footer tac mt20">
            <el-button type="default" @click="hideModal" class="action-btn mr20">取消</el-button>
            <el-button type="primary" @click="submitModal" :loading="submitLoading" class="action-btn ml20">提交</el-button>
        </p>
    </div>
</template>

<script>
    import {JtLabelCascader } from '@/components/Ele'
    import API from '@/api/workOrder/conf.js';
    export default {
        name: "TeamRuleModal",
        components:{
            JtLabelCascader,
        },
        props:{
            id:[String,Number],
            detail:Array,
            cbs:{
                type:Object,
            },
        },
        data(){
            let _this = this;
            const validateGameClassify = (rule, value, callback) => {
                if(_this.formItem.app_type=='2'){
                    if(!_this.formItem.game_classify){
                        return callback(new Error('请选择游戏分类'));
                    }else{
                        callback();
                    }
                }else {
                    callback();
                }
            };
            const validateGroupId = (rule, value, callback) => {
                if(_this.formItem.group_id.length<=0&&_this.formItem.disable_group.length<=0){
                    return callback(new Error('请选择制作部门'));
                }else{
                    callback();
                }
            };
            return {
                submitLoading:false,
                formLoading:false,
                formItem:{
                    app_type:'',
                    game_classify:'',
                    type:'',
                    group_id:[],
                    disable_group:[],
                },
                rules:{
                    app_type:[
                        { required: true, message: '请选择产品类型', trigger: 'change' },
                    ],
                    game_classify:[
                        { required: true, message: '请选择游戏分类', trigger: 'change' },
                        { validator: validateGameClassify, trigger: 'blur' },
                    ],
                    type:[
                        { required: true, message: '请选择素材类型', trigger: 'change' },
                    ],
                    group_id:[
                        { validator: validateGroupId, trigger: 'change' },
                    ],
                },
                appTypeList:[
                    {id:'1',name:'应用',},
                    {id:'2',name:'游戏',},
                ],
                gameClassifyList:[
                    {id:'3',name:'IAA',},
                    {id:'4',name:'IAP',},
                ],
                typeList:[
                    {id:'1',name:'图片',},
                    {id:'2',name:'视频',},
                ],
                groupOptions:[],
                deleteLabels:[],
            }
        },
        computed:{
            isEdit(){
                return !!this.id;
            },
        },
        mounted(){
            this.getGroupList();
            if(this.id){
                this.getRuleInfo();
            }
        },
        methods:{
            getRuleInfo(){
                this.formLoading = true;
                API.getTeamConfigInfo({
                    id: this.id,
                }).then(res=>{
                    console.log('getTeamConfigInfo',res);
                    let resData = res.data||{};
                    this.formItem.app_type = resData.app_type;
                    this.formItem.game_classify = resData.game_classify;
                    this.formItem.type = resData.type;
                    this.formItem.group_id = (resData.group||[]).map(item=>item.id);
                    this.formItem.disable_group = (resData.disable_group||[]).map(item=>item.id);
                    this.deleteLabels = resData.disable_group||[];


                    let $refItem = this.$refs.JtLabelCascader;
                    if($refItem){
                        $refItem.setDeleteLabels(this.deleteLabels);
                        $refItem.computePresentTags();
                    }

                    this.formLoading = false;
                    let detail = this.detail||[];
                    detail.forEach(item=>{
                        if(!this.formItem.group_id.includes(item)){
                            this.formItem.group_id.push(item);
                        }
                    });
                },err=>{
                    console.log('getTeamConfigInfo err',err);
                     this.formLoading = false;
                })
            },
            changeAppType(){
                this.formItem.game_classify = '';
            },
            submitModal(){
                this.$refs.form.validate((valid) => {
                    if(valid){
                        let reqData = {
                            app_type:this.formItem.app_type,
                            game_classify:this.formItem.game_classify,
                            type:this.formItem.type,
                            group_id:this.formItem.disable_group.concat(this.formItem.group_id),
                        };
                        if(this.id){
                            reqData.id = this.id;
                        }
                        this.submitLoading = true;
                        let APIType = this.id?'updateTeamConfig':'saveTeamConfig';
                        API[APIType](reqData).then(res=>{
                            this.submitLoading = false;
                            this.$message.success(res.info||'操作成功');
                            this.cbs.onSubmit('update');
                            this.hideModal();
                        },err=>{
                            this.submitLoading = false;

                            if (err.code == '403') {
                                this.$confirm(err.info||'请求异常', '提示', {
                                    confirmButtonText: '刷新',
                                    type: 'warning',
                                    showClose: false,
                                    closeOnClickModal: false,
                                    closeOnPressEscape: false
                                }).then(() => {
                                    window.location.reload()
                                }).catch(() => {
                                });
                                return
                            }
                            let errData = err.data||{};
                            if(errData.rule_id){
                                let text = `当前规则与规则ID${errData.rule_id} 重复，是否继续？继续后会将制作部门合并至该规则。`;
                                this.$confirm(err.info||text, '提示', {
                                    confirmButtonText: '继续',
                                    type: 'warning',
                                    showClose: false,
                                    closeOnClickModal: false,
                                    closeOnPressEscape: false
                                }).then(() => {
                                    // this.cbs.onEdit(errData.rule_id,this.formItem.group_id);
                                    // this.$emit('close')
                                    this.submitLoading = true;
                                    API.updateTeamConfig({
                                        id:errData.rule_id,
                                        app_type:this.formItem.app_type,
                                        game_classify:this.formItem.game_classify,
                                        type:this.formItem.type,
                                        group_id:[],
                                        new_group:this.formItem.disable_group.concat(this.formItem.group_id),
                                    }).then(res1=>{
                                        this.submitLoading = false;
                                        this.$message.success(res1.info||'操作成功');
                                        this.cbs.onSubmit('update');
                                        this.hideModal();
                                    },err1=>{
                                        this.submitLoading = false;
                                        this.$message.error(err1.info||'操作失败');
                                    });
                                }).catch(() => {
                                });

                            }else{
                                this.$message.error(err.info||'操作失败');
                            }
                        })
                    }else{
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            hideModal(){
                this.$emit('close');
            },
            getGroupList(){
                API.getTeamConfigGroup({
                    search_type: 'group',
                }).then(res=>{
                    console.log('getTeamConfigGroup',res);
                    let resData = res.data||[];
                    this.groupOptions = this._formatData(resData||[]);
                },err=>{
                    console.log('getTeamConfigGroup err',err);
                    this.groupOptions = [];
                })
            },
            changeGroup(val){
                console.log('changeGroup',val);
            },
            _formatData(arr){
                return (arr || []).map(item => {
                    // item.disabled = item.status!='1';
                    if (item.children && item.children.length > 0) {
                        item.children = this._formatData(item.children)
                    }
                    return item;
                });
            },
        }
    }
</script>

<style scoped>

</style>
